import { cx } from "@emotion/css";
import React from "react";
import "./MainContainer.css";

const MainContainer: React.FC<{ className?: string }> = ({ children, className }) => {
	return <div className={cx("main-container", className)}>{children}</div>;
};

export default MainContainer;
